"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.depthSpaces = exports.generateJSName = exports.generateBeautyName = exports.generateInterfaceFromMongooseSchema = exports.getTSType = void 0;
function getTSType(instance) {
    switch (instance) {
        case "String":
        case "ObjectID":
        case "Date":
            return "string";
        case "Number":
            return "number";
        case "Boolean":
            return "boolean";
        case "Mixed":
            return "any";
        default:
            return "any";
    }
}
exports.getTSType = getTSType;
function generateInterfaceFromMongooseSchema(mongooseSchema, jsName) {
    var ts = generateInterfaceTypes(mongooseSchema);
    return "export interface I".concat(jsName, " {\n  ").concat(ts, "\n  }\n  ");
}
exports.generateInterfaceFromMongooseSchema = generateInterfaceFromMongooseSchema;
function generateInterfaceTypes(mongooseSchema, depth) {
    if (depth === void 0) { depth = [0]; }
    var spaces = depth.map(function (item) { return "\t"; }).join("");
    var fields = Object.values(mongooseSchema.paths)
        .map(function (objPath, index) {
        if (objPath.path.endsWith("$*"))
            return ""; // Ignore $*
        var jsType = getTSType(objPath.instance);
        if (objPath.schema) {
            var res = generateInterfaceTypes(objPath.schema, __spreadArray(__spreadArray([], depth, true), [0], false));
            return "".concat(spaces).concat(objPath.path).concat(objPath.isRequired ? "" : "?", ":{\n").concat(spaces.substring(1)).concat(res, "\n").concat(spaces, "}").concat(objPath.instance === "Array" ? "[]" : "", ";");
            // return res;
        }
        else {
            if (objPath.instance === "Map") {
                return "".concat(spaces).concat(objPath.path).concat(objPath.isRequired ? "" : "?", ": {\n").concat(spaces, "  [key:string]: ").concat(getTSType(objPath.options.of.name), ";\n").concat(spaces, "};");
            }
            return "".concat(spaces).concat(objPath.path).concat(objPath.isRequired ? "" : "?", ": ").concat(jsType || "any").concat(objPath.instance === "Array" ? "[]" : "", ";");
        }
    })
        .join("\n");
    return "".concat(fields);
}
function generateBeautyName(name) {
    return name
        .split("-")
        .map(function (item) { return "".concat(item[0].toUpperCase()).concat(item.substring(1, item.length)); })
        .join(" ");
}
exports.generateBeautyName = generateBeautyName;
function generateJSName(name) {
    return generateBeautyName(name).replace(/ /gi, "");
}
exports.generateJSName = generateJSName;
function depthSpaces(depth) {
    if (depth < 0)
        return "";
    return Array.from(new Array(depth))
        .map(function (item) { return "  "; })
        .join("");
}
exports.depthSpaces = depthSpaces;
//# sourceMappingURL=index.js.map